import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";



export class ProjectInfoApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'projectInfo'
  }


  /**
   * 根据人员查找项目id
   */

  getProjectDataByUserId(userId){
    return this.send({ userId: userId}, "getProjectDataByUserId", this.Methods.GET)
  }
}
